import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Grid,
  CircularProgress,
  Container,
  Fade,
} from "@mui/material";
import useLogout from "../../context/Logout";
import { getPlaneForUser } from "../../Services/plansApi";
import RequestDemoForm from "./RequestDemoForm";
import HeroSection from "./components/HeroSection";
import PlanCard from "./components/PlanCard";

const UserDashboardTwo = () => {
  const logout = useLogout();
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [demoDialogOpen, setDemoDialogOpen] = useState(false);

  useEffect(() => {
    getPlaneForUser()
      .then((res) => {
        const palnes = res?.data?.data?.palnes || [];
        const activePlans = palnes.filter((p) => Number(p.status) === 1);
        setPlans(activePlans);
      })
      .catch(() => {
        setPlans([]);
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        py: 4,
      }}
    >
      <Container maxWidth="xl">
        <Fade in={true} timeout={1000}>
          <Box>
            <HeroSection
              logout={logout}
              onRequestDemo={() => setDemoDialogOpen(true)}
            />
          </Box>
        </Fade>

        <RequestDemoForm
          open={demoDialogOpen}
          onClose={() => setDemoDialogOpen(false)}
        />

        {/* Plans Section Header */}
        <Box sx={{ textAlign: "center", mb: 6 }}>
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: "bold",
              background: "linear-gradient(90deg, #1800ad 0%, #f57226 100%)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              mb: 2,
            }}
          >
            الباقات المتوفرة
          </Typography>
          <Typography
            variant="h6"
            color="text.secondary"
            sx={{ maxWidth: 500, mx: "auto" }}
          >
            اختر الباقة التي تناسب احتياجات مطعمك وابدأ رحلتك نحو النجاح
          </Typography>
        </Box>

        {/* Plans Grid */}
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
            <CircularProgress size={60} thickness={4} />
          </Box>
        ) : plans.length === 0 ? (
          <Box sx={{ textAlign: "center", py: 8 }}>
            <Typography variant="h6" color="text.secondary">
              لا توجد باقات متوفرة حاليًا
            </Typography>
          </Box>
        ) : (
          <Grid container spacing={4}>
            {plans.map((plan, index) => (
              <Grid item xs={12} sm={6} lg={4} key={plan.id}>
                <PlanCard plan={plan} index={index} />
              </Grid>
            ))}
          </Grid>
        )}
      </Container>
    </Box>
  );
};

export default UserDashboardTwo;
